import React from 'react';
import { useState ,useEffect } from 'react';
import './Storm.css';
import StormSvg from 'jsx:../../../assets/storm.svg';
import { useConversationStateContext } from '../../../context/ConversationContext';
import { useChatboxStateContext } from '../../../context/ChatboxContext';

function Storm({ name}) {
    const [stormTextVisibility, setVisibility] = useState(0);
    const {chatboxColor} =useConversationStateContext();
    const {valueOpen}=useChatboxStateContext();
    const [initialValueOpen, setInitialValueOpen] = useState(false);
    const onMouseEnter = () => setVisibility(0)

    const onMouseLeave = () => setVisibility(1) == null && setTimeout(() => setVisibility(2), 1000)

    const classList = ['appear', 'disappear', 'invisible'];

    const className = `kwalys-storm-text ${classList[stormTextVisibility]}`
    const svgString = `
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="22" height="28" viewBox="0 0 22 28">
            <defs>
                <path id="b" d="M19.958 518.842c-.06-.163-.232-.437-.727-.437h-3.223c-.022 0-.032-.005-.034-.004a.116.116 0 0 1 .005-.042l1.312-5.047c.111-.427.221-1.02-.103-1.246-.325-.227-.7.181-.955.508l-5.961 7.651c-.337.433-.289.771-.23.934.06.163.232.436.727.436h3.223c.022 0 .03.004.034.005 0 .004.002.018-.005.042l-1.312 5.047c-.111.426-.221 1.02.103 1.246a.342.342 0 0 0 .201.065c.27 0 .551-.313.754-.574l5.961-7.65c.338-.433.289-.771.23-.934z"/>
                <filter id="a" width="280%" height="212.5%" x="-90%" y="-56.2%" filterUnits="objectBoundingBox">
                    <feOffset in="SourceAlpha" result="shadowOffsetOuter1"/>
                    <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="3"/>
                    <feColorMatrix in="shadowBlurOuter1" values="0 0 0 0 0.0549019608 0 0 0 0 0.478431373 0 0 0 0 0.929411765 0 0 0 0.501557037 0"/>
                </filter>
            </defs>
            <g fill="none" fill-rule="nonzero" transform="translate(-4 -506)">
                <use fill="#000" filter="url(#a)" xlink:href="#b"/>
                <use fill=${chatboxColor} xlink:href="#b"/>
            </g>
        </svg>
        `;
    
useEffect(() => {
    if (valueOpen && !initialValueOpen) {
        setInitialValueOpen(true);
        const timer = setTimeout(() => {
            setVisibility(1); // Passer à 'disappear' après 4 secondes
            setTimeout(() => setVisibility(2), 1000);
            }, 4000);
            
    return () => clearTimeout(timer);
}
}, [valueOpen]);
    
    return (
        <a className="kwalys-storm" onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
             <div dangerouslySetInnerHTML={{ __html: svgString }} />
            <span  className={className} style={{ color: chatboxColor }}>{name}</span>
        </a>
    );
}

Storm.defaultProps = {
    name : 'Talkr'
}

export default Storm;